import { InviteNewBornPatient } from 'domain/usecases/patient/invite-newborn-patient'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteInviteNewBornPatient implements InviteNewBornPatient {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  add(
    params: InviteNewBornPatient.Params
  ): Promise<InviteNewBornPatient.Model> {
    return this.patientRepository.inviteNewBornPatient(params)
  }
}
